// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormPatients_wrapper__2pyuG","wrapperForm":"FormPatients_wrapperForm__fXgVY"};